"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _popover_positioned = _interopRequireDefault(require("./popover_positioned"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Popover =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Popover, _React$Component);

  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popover).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidUpdate", function () {
      var isContentVisible = _this.state.isContentVisible;

      if (isContentVisible) {
        window.addEventListener('click', _this.handleWindowClick);
        window.addEventListener('keydown', _this.handleWindowKeyDown);
      } else {
        window.removeEventListener('click', _this.handleWindowClick);
        window.removeEventListener('keydown', _this.handleWindowKeyDown);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
      window.removeEventListener('click', _this.handleWindowClick);
      window.removeEventListener('keydown', _this.handleWindowKeyDown);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleWindowClick", function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.toggleContent();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleWindowKeyDown", function (event) {
      var contentHideDelayOnHover = _this.props.contentHideDelayOnHover;

      switch (event.keyCode) {
        case 27:
          // ESC
          _this.changeState(false, contentHideDelayOnHover);

          event.preventDefault();
          break;

        case 32: // SPACE

        case 13:
          // ENTER
          event.preventDefault();
          event.stopPropagation();

          _this.toggleContent();

          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleContent", function () {
      var isContentVisible = _this.state.isContentVisible;

      _this.setState({
        isContentVisible: !isContentVisible
      }, function () {
        var onClose = _this.props.onClose;

        if (isContentVisible) {
          onClose();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeState", function (isContentVisible) {
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var changeState = function changeState() {
        return _this.setState({
          isContentVisible: isContentVisible
        });
      };

      if (timeout > 0) {
        setTimeout(changeState, timeout);
      } else {
        changeState();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleLinkClick", function (event) {
      var onClick = _this.props.onClick;
      var isContentVisible = _this.state.isContentVisible;
      event.persist();
      event.preventDefault();
      event.stopPropagation();

      _this.changeState(!isContentVisible);

      onClick(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleLinkKeyDown", function (event) {
      var contentHideDelayOnHover = _this.props.contentHideDelayOnHover;

      switch (event.keyCode) {
        case 27:
          // ESC
          _this.changeState(false, contentHideDelayOnHover);

          event.preventDefault();
          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleLinkMouseEnter", function (event) {
      var contentShowDelayOnHover = _this.props.contentShowDelayOnHover;
      event.preventDefault();

      _this.changeState(true, contentShowDelayOnHover);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleLinkMouseLeave", function (event) {
      var contentHideDelayOnHover = _this.props.contentHideDelayOnHover;
      event.preventDefault();

      _this.changeState(false, contentHideDelayOnHover);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handlers", function () {
      var interactionType = _this.props.interactionType;

      if (interactionType === 'click') {
        return {
          onClick: _this.handleLinkClick,
          onKeyDown: _this.handleLinkKeyDown
        };
      }

      if (interactionType === 'hover') {
        return {
          onClick: _this.handleLinkClick,
          onKeyDown: _this.handleLinkKeyDown,
          onMouseEnter: _this.handleLinkMouseEnter,
          onMouseLeave: _this.handleLinkMouseLeave
        };
      }

      return {};
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validateAlignment", function (position, alignment) {
      var invalidCombinations = {
        up: ['top', 'bottom'],
        down: ['top', 'bottom'],
        right: ['right', 'left'],
        left: ['right', 'left']
      };
      var invalidAlignments = invalidCombinations[position];

      if (invalidAlignments && invalidAlignments.includes(alignment)) {
        return 'middle';
      }

      return alignment;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
      var _this$props = _this.props,
          alignment = _this$props.alignment,
          children = _this$props.children,
          placement = _this$props.placement,
          position = _this$props.position,
          otherProps = _objectWithoutProperties(_this$props, ["alignment", "children", "placement", "position"]);

      var isContentVisible = _this.state.isContentVisible;
      return _react.default.createElement(_popover_positioned.default, _extends({}, otherProps, {
        alignment: _this.validateAlignment(position, alignment),
        contentVisible: isContentVisible,
        interactionHandlers: _this.handlers(),
        placement: placement,
        position: position
      }), children);
    });

    _this.state = {
      isContentVisible: false
    };
    return _this;
  }

  return Popover;
}(_react.default.Component);

Popover.alignmentOptions = ['top', 'right', 'bottom', 'left', 'middle'];
Popover.placementOptions = ['auto', 'manual'];
Popover.positionOptions = ['up', 'right', 'down', 'left'];
Popover.propTypes = {
  alignment: _propTypes.default.oneOf(Popover.alignmentOptions),
  arrow: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  content: _propTypes.default.node.isRequired,
  contentClassName: _propTypes.default.string,
  contentHideDelayOnHover: _propTypes.default.number,
  contentShowDelayOnHover: _propTypes.default.number,
  interactionType: _propTypes.default.oneOf(['click', 'hover']),
  onClick: _propTypes.default.func,
  onClose: _propTypes.default.func,
  placement: _propTypes.default.oneOf(Popover.placementOptions),
  position: _propTypes.default.oneOf(Popover.positionOptions),
  targetClassName: _propTypes.default.string,
  targetRole: _propTypes.default.string,
  targetTabIndex: _propTypes.default.number,
  useJsPositioning: _propTypes.default.bool
};
Popover.defaultProps = {
  alignment: 'left',
  arrow: false,
  className: null,
  contentClassName: null,
  contentHideDelayOnHover: 0,
  contentShowDelayOnHover: 0,
  interactionType: 'click',
  onClick: function onClick() {},
  onClose: function onClose() {},
  placement: 'manual',
  position: 'down',
  targetClassName: null,
  targetRole: 'menu',
  targetTabIndex: 0,
  useJsPositioning: false
};
Popover.displayName = 'Popover';
var _default = Popover;
exports.default = _default;